import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Photo } from '../../models/cameralla-photo.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReviewPopupComponent } from '../../../modules/photo/photo-review/review-popup/review-popup.component';
import { RatingService } from '../../../modules/photo/services/rating.service';
import { ToastrService } from 'ngx-toastr';
import { CamerallaAuthService } from '../../services/authentication-services/cameralla-auth.service';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import * as $ from 'jquery';
import { AppComponent } from '../../../app.component';
import { LikeService } from '../../../modules/photo/services/like.service';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import AppShareHelper from '../../utils/helper';
import { GlobalVariables } from "../../models/cameralla-global.model";
import { AdvertisingService } from "../../services/advertising.service";
import { UserStatusConstant } from "../../constants/user-status-constant";
import { PopupMarkerComponent } from "../popup-marker/popup-marker.component";
import { AdsSubTypeConstant, AdsTypeConstant } from "../../constants/ads-type-constant";
import { Router } from "@angular/router";

@Component({
    selector: 'app-photo-card',
    templateUrl: './photo-card.component.html',
})
export class PhotoCardComponent implements OnInit {
    @Input('photo') photo: Photo;
    @Input('photoNumber') photoNumber: number;
    @Input('newPhotos') newPhotos: number;
    @Input('classImage') classImage: any;
    @Input('hiddenRating') hiddenRating = false;
    @Input('profileView') profileView = null;
    @Input('fromVip') fromVip = false;
    @Output('notify') notify: EventEmitter<boolean> = new EventEmitter<boolean>();

    static photosLoaded = 0;
    static numberOfNewPhotoLoaded = 0;

    defaultErrorPhoto = './assets/images/default-error-photo.png';
    criterion = ['general', 'vision', 'composition', 'cameraSettings', 'editing', 'presentation'];
    rating = 0;
    userRating = 0;
    updateStatus = 0;
    currentRating = 0;
    makeRequest$;
    public userId;
    promiseLike;
    imageManagement = {};
    source = null;
    onLoadImageError = false;

    constructor(private _modalService: NgbModal,
                public ratingService: RatingService,
                public router: Router,
                private toastr: ToastrService,
                private authService: CamerallaAuthService,
                private likeService: LikeService,
                private advertisingService: AdvertisingService,

                private cdr: ChangeDetectorRef
    ) {
        this.makeRequest$ = new Subject();

        this.makeRequest$.pipe(switchMap((params: any) => {
            return this.ratingService.updateRating(params.owner_rating, params.owner_rating_id);
        })).subscribe((response) => {
            if (response['IsSuccess']) {
                this.updateStatus = 2;
                this.photo.ratings.general = response['Data'].ratings.general;
                this.photo.ratings.general_count = response['Data'].ratings.general_count;
                this.currentRating = response['Data'].ratings.general;
                this.toastr.success('Give rating successfully', 'SUCCESS');

                setTimeout(() => {
                    this.updateStatus = 0;
                    this.cdr.detectChanges();
                }, 1000);
            } else {
                this.toastr.error('Something went wrong. Please try again later', 'ERROR');
                this.updateStatus = 0;
            }
        });
    }

    updatePhotoView(photo) {
        if (!this.photo.ratings) {
            this.photo.ratings = Photo.getDefaultRating();
        }

        if (photo.ratings) {
            this.photo.ratings.general = photo.ratings.general;
            this.photo.ratings.general_count = photo.ratings.general_count;
        }
        this.photo.commentsCount = photo.commentsCount;
        this.photo.owner_rating = photo.owner_rating;
        this.photo.isGoldenLocation = photo.isGoldenLocation;
        this.photo.isGolden = photo.isGolden;

        if (photo.owner_rating) {
            this.currentRating = this.userRating = AppShareHelper.getViewRatingPoint(photo.owner_rating.general);
        }

        this.cdr.detectChanges();
    }

    getViewRatingPoint(value) {
        return AppShareHelper.getViewRatingPoint(value);
    }

    ngOnInit() {
        this.userId = +this.authService.getLocalUserInfo()['id'];
        this.userRating = AppShareHelper.getViewRatingPoint((this.photo.owner_rating && this.photo.owner_rating.general) || 0);
        this.currentRating = this.userRating;
        if (!this.photo.height || !this.photo.width) {
            this.photo.height = 280;
            this.photo.width = 350;
        }

        if (this.photo.customer && this.photo.customer.status == UserStatusConstant.DELETED) {
            this.photo.customer.fullName = 'Deleted user'
        }

        if (environment.production) {
            AppShareHelper.convertToHttps(this.photo, 'original');
            AppShareHelper.convertToHttps(this.photo, 'thumbnail');
        }
    }

    calculateImageSize() {
        return AppShareHelper.calculateImageSize(this.photo);
    }

    getClassMapper(type) {
        switch (type) {
            case 1: {
                return 'primary';
            }
            case 2: {
                //statements;
                return 'secondary';
            }
            case 3: {
                //statements;
                return 'success';
            }
            case 4: {
                //statements;
                return 'danger';
            }
            case 5: {
                //statements;
                return 'warning';
            }
            case 6: {
                //statements;
                return 'info';
            }
            default: {
                //statements;
                return 'light';
            }
        }

    }

    totalStars(ratings) {
        let total = 0;
        for (const each of this.criterion) {
            total += ratings[`${each}_count`];
        }
        if (isNaN(total)) {
            return 0;
        }
        return total;
    }

    errorPhoto() {
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !/AppleWebKit(.*)(?=Crios)(.*)/igm.test(navigator.userAgent)) {
            AppComponent.eventOnImageError.next();
        }
        this.onLoadImageError = true;
        this.imageManagement[this.photo.id] = true;
        this.photo.height = 280;
        this.photo.width = 350;
        this.calculateImageSize();
        this.photo.thumbnail = this.defaultErrorPhoto;
        this.imageManagement[this.photo.id] = true;
    }

    loaded() {
        this.imageManagement[this.photo.id] = true;
        PhotoCardComponent.photosLoaded++;
        PhotoCardComponent.numberOfNewPhotoLoaded++;

        this.notify.emit(PhotoCardComponent.photosLoaded >= this.photoNumber
            || (PhotoCardComponent.photosLoaded + 10) >= this.photoNumber
            || PhotoCardComponent.photosLoaded >= this.newPhotos
            || PhotoCardComponent.numberOfNewPhotoLoaded >= 10
        );

        setTimeout(() => {
            this.cdr.detach();
        }, 3000);

    }


    public openDetail(photoId) {
        const tempScrollTop = $(window).scrollTop();
        //Todo: Tempo fix
        localStorage.setItem(GlobalVariables.CURRENT_PARTNER.value + 'scrollPosition', tempScrollTop);
        if (!this.profileView) {
            this.router.navigate(['/photo/' + photoId]);
        } else {
            this.router.navigate(['/photo/' + photoId], {queryParams: { userId: this.profileView }});
        }
    }

    attachChange() {
        this.cdr.reattach();
    }

    detachChange() {
        this.cdr.detach();
    }

    updatePhoto(event) {
        if (this.userRating == 0) {
            setTimeout(() => {
                this.userRating = AppShareHelper.getViewRatingPoint(this.photo.owner_rating.general);
            });
            return;
        }

        let sendingDataPoint = AppShareHelper.getRealRatingPoint(this.userRating);

        this.updateStatus = 1;
        if (this.photo.owner_rating) {
            this.photo.owner_rating.general = sendingDataPoint;
            this.photo.owner_rating.cameraSettings = sendingDataPoint;
            this.photo.owner_rating.composition = sendingDataPoint;
            this.photo.owner_rating.presentation = sendingDataPoint;
            this.photo.owner_rating.vision = sendingDataPoint;
            this.photo.owner_rating.editing = sendingDataPoint;

            this.makeRequest$.next({
                owner_rating: this.photo.owner_rating,
                owner_rating_id: this.photo.owner_rating.id
            });

        } else {
            this.photo.owner_rating = Photo.getDefaultOwnerRating({
                customerId: this.authService.getLocalUserInfo()['id'],
                general: sendingDataPoint,
                editing: sendingDataPoint,
                vision: sendingDataPoint,
                presentation: sendingDataPoint,
                composition: sendingDataPoint,
                cameraSettings: sendingDataPoint,
                photoId: this.photo.id,
            });

            this.ratingService.ratePhoto(this.photo.owner_rating).toPromise().then(
                response => {
                    if (response['IsSuccess']) {
                        this.photo.ratings = Photo.getDefaultRating({});
                        this.updateStatus = 2;
                        this.photo.owner_rating.create_at = moment().format();
                        this.photo.owner_rating.id = response['Data'].owner_rating.id;
                        this.photo.ratings.general = response['Data'].ratings.general;
                        this.photo.ratings.general_count = response['Data'].ratings.general_count;
                        this.currentRating = response['Data'].ratings.general;
                        this.toastr.success('Give rating successfully', 'SUCCESS');
                        setTimeout(() => {
                            this.updateStatus = 0;
                            this.cdr.detectChanges();
                        }, 1000);
                    } else {
                        this.userRating = this.currentRating;
                        this.updateStatus = 0;
                        this.toastr.error('Something went wrong. Please try again later', 'ERROR');
                    }
                },
                error => {
                    setTimeout(() => {
                        this.userRating = this.currentRating;
                        this.cdr.detectChanges();
                    }, 0)
                }
            );
        }
    }

    openCommentDetail() {
        const modal = this._modalService.open(ReviewPopupComponent, {centered: true});
        (<ReviewPopupComponent>modal.componentInstance).photoDetails = this.photo;
    }

    public likeAction(option) {
        this.promiseLike = this.likeService.like({
            'customerId': this.userId,
            'photoId': this.photo.id,
            'like': option
        }).toPromise().then((res: any) => {
            if (res.Data) {
                this.photo.owner_like = option;
                this.photo.likesCount = res.Data.likesCount;
            }
        }, err => {
            this.toastr.error('Something went wrong. Please try again later', 'ERROR');
        }).catch((e) => {
            this.toastr.error('Something went wrong. Please try again later', 'ERROR');
        });
    }

    public convertPrettifyNumber(value) {
        return this.likeService.convertPrettifyNumber(value);
    }

    preventDefault(event, photo) {
        this.advertisingService.clickingAds(photo.rawId).subscribe();

        if (photo.adsType == AdsTypeConstant.VIDEO_ADS) {
            const modalRef = this._modalService.open(PopupMarkerComponent, {
                centered: true,
                size: "lg"
            });
            modalRef.componentInstance.videoId = photo.navigateUrl;
            event.preventDefault();
        }

        if (!photo.navigateUrl && photo.adsType == AdsTypeConstant.FEED_ADS && photo.subType == AdsSubTypeConstant.PINNED) {
            event.preventDefault();
            return;
            // const modalRef = this._modalService.open(PopupMarkerComponent, {
            //     centered: true,
            //     size: "lg"
            // });
            // modalRef.componentInstance.title = 'Tema: Vår';
            // modalRef.componentInstance.titleClass = 'text-center'
            // modalRef.componentInstance.body = 'Våren er kanskje den årstiden som er mest kjærkommen. Den gir nytt liv både til planter, dyr og oss mennesker. Vårtegn er mer enn en hestehov. Det kan være en russ, den første sommerfuglen, en andunge, et lite lam, smeltevann, den første sykkelturen…. <br><br>' +
            //     'Motivet er opp til deg. Her er mulighetene mange. Men knytt gjerne en god tekst til bildet, så blir assosiasjonene til alle som ser bildet ditt sterkere. Inspirer oss andre, og bli selv inspirert. Kreativitet i bildene dine er viktig! Lykke til! <br><br>';
            //     } else if (!photo.navigateUrl || photo.adsType == AdsTypeConstant.VIDEO_ADS) {
            // event.preventDefault();
        } else {
            return;
        }
    }
}
